module.exports = require('../dist/apollo')
